module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16GpocJ/tc-custom/9781398476646.jpg?1705766123512",
      "alt": "This image is the cover for the book The Secret of a Seminarian"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Secret of a Seminarian\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sergio was born into a traditional Christian family in the ’80s. His mother, a devout Catholic, was always his protection; she always loved and protected him, and his father was the man he always wanted to become in the future and his inspiration. However, as he grew older, his mother began to see something different in him, and this became more evident as he passed puberty; she saw his sadness and his way of being, and felt more ashamed of her own son. Little by little, the love that his mother had for him was changing; Sergio noticed his mother was more distant and the sweet words of affection that she had said before turned into frightened looks. All the while his father harassed him more and more, reaching the point of several times attacking him in the heat of emotion. In the hope of being able to change him, his family decided to take him to a seminary so that any demon he had inside him could be removed, but when he arrived at the seminary, Sergio found two very different men who completely change his life and his vision of seeing the world.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jandira Kapapelo\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("My name is Jandira, I was born and raised in Angola and I moved to London in 2020. I have a degree in management, and two master’s degrees, one in marketing and one in accounting.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0